// Trends report with UTM breakdown (`source_request.trends_utm_breakdown`) always needs the
// hierarchical UTM query/render path — the backend dispatches to TrendsUtmQueryService whenever
// this flag is set (see QueryService::getService in www), independent of which line/bar chart
// type is picked for it. Before that decoupling, the only way to signal "UTM mode" was to force
// `type_chart` itself to the literal 'utm_trends', which also locked out the normal chart-type
// selector. Reports saved back then still carry that literal value, so it's still recognized here.
export function isUtmTrendsBreakdown(reportData) {
  if (!reportData) return false
  if (reportData.type_chart === 'utm_trends') return true
  return reportData.type === 'trends' && !!reportData.source_request?.trends_utm_breakdown
}

// The literal 'utm_trends' type_chart is legacy-only now — normalize it to a real line/bar
// value so components that render or select a chart type (ControlChart, _chart.vue's
// isLineType/isBarType) have something meaningful to work with.
export function effectiveChartType(reportData) {
  const t = reportData?.type_chart
  return t === 'utm_trends' ? 'line' : (t || 'line')
}
